import { SxProps, Theme } from '@mui/material';

export const MethodButtonStyles = (theme: Theme, isSelected: boolean): Record<string, SxProps<Theme>> => ({
  mainContainer: {
    width: '80px',
    fontSize: '12px',
    borderRadius: '0.5rem',
    padding: '0',
    paddingBlock: '0.3rem',
    display: 'flex',
    flexDirection: 'column',
    color: '#ffffff',
    borderColor: isSelected ? theme.palette.primary.main : theme.palette.primary.contrastText,
    backgroundColor: isSelected ? theme.palette.primary.main : 'transparent',
    '&:hover': {
      backgroundColor: theme.palette.primary.main
    }
  }
});
